// extracted by mini-css-extract-plugin
export default {"section":"QuickContactList_section__i0i+m","pricingServices":"QuickContactList_pricingServices__2xXd7","servicesWrapper":"QuickContactList_servicesWrapper__YTb7Y"};